module.exports = __webpack_public_path__ + "img/w3_sort_white.879883a3.png";